import React from 'react'
import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate, useLocation, useNavigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import useAuth from '../../hooks/useAuth'
import {resolveRoleIndex, roles} from '../../roles'
import RTLProvider from './RTLProvider'
import ErrorBoundary from '../../components/ErrorBoundary'
const PrivateRoutes = () => {
  const LicensesPage = lazy(() => import('../pages/LicensesPage'))
  const UsersPage = lazy(() => import('../pages/UsersPage'))
  const EstablishementPage = lazy(() => import('../pages/EstablishementsPage'))
  const ClassesPage = lazy(() => import('../pages/ClassesPage'))
  const SubjectsPage = lazy(() => import('../pages/SubjectsPage'))
  const TypeExamsPage = lazy(() => import('../pages/TypeExams'))
  const TypeRemarquesPage = lazy(() => import('../pages/TypeRemarques'))
  const PaymentCategoriesPage = lazy(() => import('../pages/PaymentCategories'))
  const PaymentsPage = lazy(() => import('../pages/Payments'))
  const ExpendituresPage = lazy(() => import('../pages/Expenditures'))
  const RemarquesPage = lazy(() => import('../pages/Remarques'))
  const ExercicesPage = lazy(() => import('../pages/ExercicesPage'))
  const FileManagerPage = lazy(() => import('../pages/FileManagerPage/index'))
  const ExamsPage = lazy(() => import('../pages/ExamsPage'))
  const ProfilePage = lazy(() => import('../pages/ProfilePage'))
  const PromotionsPage = lazy(() => import('../pages/Promotions'))
  const StatistiquePage = lazy(() => import('../pages/Statistiques'))
  const ChatbotPage = lazy(() => import('../pages/ChatbotPage'))
  const InventoryManagementPage = lazy(() => import('../pages/InventoryManagementPage'))
  const InventoryTypePage = lazy(() => import('../pages/InventoryTypePage'))
  const InventoryStatisticsPage = lazy(() => import('../pages/InventoryStatisticsPage'))
  const EmailManagementPage = lazy(() => import('../pages/EmailManagement'))
  const GamingPanelPage = lazy(() => import('../pages/GamingPanel'))

  const location = useLocation()
  const navigate = useNavigate()
  const {me} = useAuth()
  React.useEffect(() => {
    if (me && location) {
      const roleIndex = resolveRoleIndex(me.role)
      console.log('🔍 PrivateRoutes - Current pathname:', location.pathname)
      console.log('🔍 PrivateRoutes - User role:', me.role)
      console.log('🔍 PrivateRoutes - Resolved role index:', roleIndex)
      console.log('🔍 PrivateRoutes - User roles:', roleIndex !== null ? roles[roleIndex] : undefined)
      if (roleIndex === null) {
        console.warn('⚠️ PrivateRoutes - Unable to resolve role index, leaving current route unchanged.')
        return
      }
      let authorized = false
      const userRoles = roles[roleIndex]
      if (!userRoles) {
        console.warn('⚠️ PrivateRoutes - No roles configured for index:', roleIndex)
        return
      }
      
      // More robust authorization check
      userRoles.forEach((role) => {
        console.log('🔍 PrivateRoutes - Checking role:', role, 'against pathname:', location.pathname)
        
        // Check for exact match or path starts with role + '/'
        if (location.pathname === role || 
            location.pathname.startsWith(role + '/')) {
          console.log('🔍 PrivateRoutes - ✅ Authorized! Role', role, 'matches pathname')
          authorized = true
        }
      })
      
      console.log('🔍 PrivateRoutes - Final authorization result:', authorized)
      
      if (!authorized) {
        console.log('🔍 PrivateRoutes - ❌ Not authorized, redirecting to:', userRoles[0])
        navigate(userRoles[0])
      } else {
        console.log('🔍 PrivateRoutes - ✅ Access granted to:', location.pathname)
      }
    }
  }, [location, me])
  return (
    <ErrorBoundary>
      <Routes>
        <Route element={<MasterLayout />}>
          {/* Redirect to Dashboard after success login/registartion */}
          {/* Pages */}
          {/* Lazy Modules */}
          {/*<Route
          path='/licenses/*'
          element={
            <SuspensedView>
              <LicensesPage />
            </SuspensedView>
          }
        /> */}
          <Route
            path='/profile'
            element={
              <SuspensedView>
                <ProfilePage />
              </SuspensedView>
            }
          />

          <Route
            path='/users/:id/edit'
            element={
              <SuspensedView>
                <ProfilePage />
              </SuspensedView>
            }
          />
          <Route
            path='/users/*'
            element={
              <SuspensedView>
                <UsersPage />
              </SuspensedView>
            }
          />
          <Route
            path='/kids'
            element={
              <SuspensedView>
                <UsersPage />
              </SuspensedView>
            }
          />
          <Route
            path='/kids/:id/edit'
            element={
              <SuspensedView>
                <ProfilePage />
              </SuspensedView>
            }
          />
          <Route
            path='/inventory/*'
            element={
              <SuspensedView>
                <InventoryManagementPage />
              </SuspensedView>
            }
          />
          <Route
            path='/inventory-types/*'
            element={
              <SuspensedView>
                <InventoryTypePage />
              </SuspensedView>
            }
          />
          <Route
            path='/inventory-statistics'
            element={
              <SuspensedView>
                <InventoryStatisticsPage />
              </SuspensedView>
            }
          />
          <Route
            path='/games'
            element={
              <SuspensedView>
                <GamingPanelPage />
              </SuspensedView>
            }
          />
          <Route
            path='/file-manager'
            element={
              <SuspensedView>
                <FileManagerPage />
              </SuspensedView>
            }
          />
          <Route
            path='/email-management/*'
            element={
              <SuspensedView>
                <EmailManagementPage />
              </SuspensedView>
            }
          />
          <Route
            path='/establishements/*'
            element={
              <SuspensedView>
                <EstablishementPage />
              </SuspensedView>
            }
          />
          <Route
            path='/classes/*'
            element={
              <SuspensedView>
                <ClassesPage />
              </SuspensedView>
            }
          />
          <Route
            path='/subjects/*'
            element={
              <SuspensedView>
                <SubjectsPage />
              </SuspensedView>
            }
          />
          <Route
            path='/type-exams/*'
            element={
              <SuspensedView>
                <TypeExamsPage />
              </SuspensedView>
            }
          />
          <Route
            path='/type-remarques/*'
            element={
              <SuspensedView>
                <TypeRemarquesPage />
              </SuspensedView>
            }
          />
          <Route
            path='/payment-categories/*'
            element={
              <SuspensedView>
                <PaymentCategoriesPage />
              </SuspensedView>
            }
          />
          <Route
            path='/payments/*'
            element={
              <SuspensedView>
                <PaymentsPage />
              </SuspensedView>
            }
          />
          <Route
            path='/expenditures/*'
            element={
              <SuspensedView>
                <ExpendituresPage />
              </SuspensedView>
            }
          />
          <Route
            path='/remarques/*'
            element={
              <SuspensedView>
                <RemarquesPage />
              </SuspensedView>
            }
          />
          <Route
            path='/exams/*'
            element={
              <SuspensedView>
                <ExamsPage />
              </SuspensedView>
            }
          />
          <Route
            path='/exercices/*'
            element={
              <SuspensedView>
                <ExercicesPage />
              </SuspensedView>
            }
          />
          <Route
            path='/promotions/*'
            element={
              <SuspensedView>
                <PromotionsPage />
              </SuspensedView>
            }
          />
          <Route
            path='/statistiques/*'
            element={
              <SuspensedView>
                <StatistiquePage />
              </SuspensedView>
            }
          />
          <Route
            path='/chatbot/*'
            element={
              <SuspensedView>
                <ChatbotPage />
              </SuspensedView>
            }
          />


          {/* Page Not Found */}
          <Route path='*' element={<Navigate to='/error/404' />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  )
}

const SuspensedView: FC<SuspensedViewProps> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}
interface SuspensedViewProps {
  children: React.ReactNode
}
export {PrivateRoutes}
